<template>
    <div class="container">
        <section class="section">
            <div class="u-mb-3">
                <div class="u-mb-3 u-pb-0-5"></div>
                <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center flex-gap-16">
                    <div class="d-flex flex-gap-8 align-items-center u-mt-0-5 u-mb-lg-1">
                        <div class="h2 font-weight--bold u-mb-0 line-height--h3">Pay</div>
                    </div>
                    <div class="text--md d-lg-none">Hi CIELO MARGARITA, what type of payment do you want to make
                        today?
                    </div>
                </div>
                <div class="text--md d-none d-lg-block">Hi CIELO MARGARITA, what type of payment do you want to
                    make today?
                </div>
            </div>
            <div class="section__content">
                <div class="d-flex flex-column justify-content-around flex-gap-24">
                    <div class="card flex-basis-even mb-0 card--hover cur--p">
                        <div class="d-flex flex-row justify-content-between align-items-center u-px-2 u-px-md-3 card__body">
                            <div class="d-flex px-0 align-items-center col-12 col-md-10">
                                <img
                                    src="@/assets/img/depay-banner.png" alt="Pay merchant"
                                    class="u-pr-2">
                                <div class="d-flex flex-column"><p class="text--md font-weight--bold u-mb-1">Pay
                                    merchant</p>
                                    <p class="text--md u-m-0">Pay easily by entering Pix Key.</p></div>
                            </div>
                            <div class="d-none d-md-flex px-0 justify-content-end align-items-center col-md-2">
                                <span class="status-bubble status-bubble--completed u-mr-2">New</span>
                                <svg viewBox="0 0 24 24" class="icon">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="card flex-basis-even mb-0 card--hover cur--p">
                        <div class="d-flex flex-row justify-content-between align-items-center u-px-2 u-px-md-3 card__body">
                            <div class="d-flex px-0 align-items-center col-12 col-md-11">
                                <img
                                    src="@/assets/img/airtm-me-banner.png" alt="Airtm.me"
                                    class="u-pr-2">
                                <div class="d-flex flex-column"><p class="text--md font-weight--bold u-mb-1">
                                    Airtm.me</p>
                                    <p class="text--md u-m-0">Share your link to receive payments from anyone
                                        via US bank transfer, card, and stablecoins.</p></div>
                            </div>
                            <div class="d-none d-md-flex px-0 justify-content-end align-items-center col-md-1">
                                <svg viewBox="0 0 24 24" class="icon">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="card flex-basis-even mb-0 card--hover cur--p">
                        <div class="d-flex flex-row justify-content-between align-items-center u-px-2 u-px-md-3 card__body">
                            <div class="d-flex px-0 align-items-center col-12 col-md-11">
                                <img
                                    src="@/assets/img/send-banner.png" alt="Send"
                                    class="u-pr-2">
                                <div class="d-flex flex-column"><p class="text--md font-weight--bold u-mb-1">
                                    Send</p>
                                    <p class="text--md u-m-0">Send funds to current Airtm users or new users,
                                        inviting them to create an account.</p></div>
                            </div>
                            <div class="d-none d-md-flex px-0 justify-content-end align-items-center col-md-1">
                                <svg viewBox="0 0 24 24" class="icon">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="card flex-basis-even mb-0 card--hover cur--p">
                        <div class="d-flex flex-row justify-content-between align-items-center u-px-2 u-px-md-3 card__body">
                            <div class="d-flex px-0 align-items-center col-12 col-md-11">
                                <img
                                    src="@/assets//img/pay-local-banner.png" alt="Pay Local"
                                    class="u-pr-2">
                                <div class="d-flex flex-column"><p class="text--md font-weight--bold u-mb-1">Pay
                                    Local</p>
                                    <p class="text--md u-m-0">Send funds to anyone's local payment method doing
                                        a P2P withdrawal.</p></div>
                            </div>
                            <div class="d-none d-md-flex px-0 justify-content-end align-items-center col-md-1">
                                <svg viewBox="0 0 24 24" class="icon">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="card flex-basis-even mb-0 card--hover cur--p">
                        <div class="d-flex flex-row justify-content-between align-items-center u-px-2 u-px-md-3 card__body">
                            <div class="d-flex px-0 align-items-center col-12 col-md-11">
                                <img
                                    src="@/assets/img/request-banner.png" alt="Request"
                                    class="u-pr-2">
                                <div class="d-flex flex-column"><p class="text--md font-weight--bold u-mb-1">
                                    Request</p>
                                    <p class="text--md u-m-0">Request funds from an individual or business to be
                                        paid with Card, Bank transfer, or Airtm</p></div>
                            </div>
                            <div class="d-none d-md-flex px-0 justify-content-end align-items-center col-md-1">
                                <svg viewBox="0 0 24 24" class="icon">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "index",
    }
</script>

<style scoped>

</style>